import { configureStore } from '@reduxjs/toolkit';
import thunk from 'redux-thunk';
import {
    columnsReducer,
    addEndumReducer, // Ameersha N : 17-11-2023 : BT-116461 Breeze - Addendum and Notices 
    ipoReducer, netPositionReducer, newProductsReducer, watchlistReducer, mutualFundReducer,
    marketOverviewReducer, ordersReducer, recommendationReducer, newsReducer, eventReducer, holdingsReducer, dontMissReducer, alertsReducer,
    authReducer, notesReducer, screenersReducer, indicesReducer, portfolioReducer, fundsReducer, investmentsReducer, optionChainReducer,
    livePulseReducer, notificationsReducer, appInfoReducer, placeOrderMultilegReducer, modalsReducer, toastReducer, messagesReducer, wfhReducer, walkthroughPopoverReducer, settingReducer, edisReducer, helpReducer, calculatorReducer, guestUserReducer
} from './reducers';
import globalSearchReducer from './reducers/globalSearch';
import scripInfoReducer from './reducers/scripInfo';
import orderCartReducer from './reducers/orderCartReducer';
import { bIsProd } from '../utils/global_functions';


export const store = configureStore({
    reducer: {
        columns: columnsReducer,
        addendumreducer: addEndumReducer,// Ameersha N : 17-11-2023 : BT-116461 Breeze - Addendum and Notices 
        watchList: watchlistReducer,
        netPosition: netPositionReducer,
        ipo: ipoReducer,
        newProducts: newProductsReducer,
        mutualFund: mutualFundReducer,
        marketOverview: marketOverviewReducer,
        orders: ordersReducer,
        recommendation: recommendationReducer,
        news: newsReducer,
        events: eventReducer,
        dontMiss: dontMissReducer,
        holdings: holdingsReducer,
        alerts: alertsReducer,
        notes: notesReducer,
        screeners: screenersReducer,
        auth: authReducer,
        indices: indicesReducer,
        portfolio: portfolioReducer,
        funds: fundsReducer,
        investments: investmentsReducer,
        livePulse: livePulseReducer,
        appInfo: appInfoReducer,
        globalSearch: globalSearchReducer,
        placeOrder: placeOrderMultilegReducer,
        modals: modalsReducer,
        toast: toastReducer,
        walkthroughPopovers: walkthroughPopoverReducer,
        setting: settingReducer,
        messages: messagesReducer,
        notification: notificationsReducer,
        wfh: wfhReducer,
        scripInfo: scripInfoReducer,
        optionChain: optionChainReducer,
        guestUser: guestUserReducer,
        edis: edisReducer,
        help: helpReducer,
        orderCart: orderCartReducer, //SRIAKNTHRAO-ORDERCART
        calculator: calculatorReducer

    },
    middleware: [thunk],
    devTools: !bIsProd() // This value as false will stop showing in data in redux devtools in build
});

